import type { FC } from 'react';
import { useLocation } from 'react-router';
import { Link } from 'src/components/navigation/link';
import { Tabs } from 'src/components/navigation/tabs';
import { useOptionalAuthenticatedMonolithUser } from 'src/hooks/use-monolith-user';

export const NotificationsTabs: FC = () => {
  const { pathname, hash } = useLocation();
  const monolithUser = useOptionalAuthenticatedMonolithUser();

  if (!(monolithUser?.isShipper || monolithUser?.isTso)) return null;

  return (
    <Tabs>
      <Link to="/notifications">
        Notifications {monolithUser.isTso && 'NEW'}
      </Link>

      {monolithUser.isShipper && (
        <Link
          to="/platform/#/activity"
          isActive={pathname.startsWith('/platform') && hash === '#/activity'}
        >
          Activities
        </Link>
      )}

      {monolithUser.isTso && (
        <Link
          to="/platform/#/notifications"
          isActive={
            pathname.startsWith('/platform') && hash === '#/notifications'
          }
        >
          Notifications
        </Link>
      )}
    </Tabs>
  );
};
